// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const PlanTasksCalendarViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-plantaskscalendarview" */ "./PlanTasksCalendarView")).then((page)=>{
        return {
            default: page.PlanTasksCalendarView
        };
    });
export const LazyPlanTasksCalendarView = /*#__PURE__*/ lazy(PlanTasksCalendarViewLazyLoader);
